import { OptimizelyProvider as OptimizelyProviderDefault } from '@optimizely/react-sdk';
import React, { useEffect, useState } from 'react';
import initOptimizely from 'src/utils/initOptimizely';
import { v4 as uuidv4 } from 'uuid';

import { OPTIMIZELY_USER_ID_STORAGE_KEY } from './constants';

const optimizelyInstance = initOptimizely();

export function getUserAttributes(id: string | null) {
  return {
    internalStaff: id ? id?.toLowerCase().endsWith('ovo.com') : false,
  };
}

export function getInitialUser() {
  if (typeof window === 'undefined') {
    return { id: 'unknown' };
  }
  const storedId = sessionStorage.getItem(OPTIMIZELY_USER_ID_STORAGE_KEY);
  return { id: storedId || 'unknown', attributes: getUserAttributes(storedId) };
}

const OptimizelyProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState(getInitialUser);

  useEffect(() => {
    const storedId = sessionStorage.getItem(OPTIMIZELY_USER_ID_STORAGE_KEY);
    if (storedId) {
      setUser({ id: storedId });
      return;
    }

    const newUserId = uuidv4();
    setUser({ id: newUserId });
    window.sessionStorage.setItem(OPTIMIZELY_USER_ID_STORAGE_KEY, newUserId);
  }, []);

  return (
    <OptimizelyProviderDefault optimizely={optimizelyInstance} user={user} timeout={30}>
      {children}
    </OptimizelyProviderDefault>
  );
};

export default OptimizelyProvider;
